module.exports = __webpack_public_path__ + "9be819c2cbdf309aff05326bbe19ac61.png";